import React from 'react';
import BlogIcon from './BlogIcon';

/** اسکلت کارت مقاله: نسبت ۱۶:۹ تصویر و ارتفاع بدنه ثابت تا چیدمان نپرد */
export const ArticleCardSkeleton: React.FC = () => (
  <div className="overflow-hidden rounded-[12px] border border-[#f0eeea] bg-white" aria-hidden>
    <div className="blog-skeleton aspect-video w-full rounded-t-[11px]" />
    <div className="flex flex-col items-end gap-3 p-5">
      <div className="blog-skeleton h-4 w-20" />
      <div className="blog-skeleton h-5 w-full" />
      <div className="blog-skeleton h-5 w-[72%]" />
      <div className="blog-skeleton h-3 w-full" />
      <div className="blog-skeleton h-3 w-[60%]" />
      <div className="flex w-full items-center justify-between border-t border-[#f0eeea] pt-3">
        <div className="blog-skeleton h-3 w-16" />
        <div className="blog-skeleton h-3 w-24" />
      </div>
    </div>
  </div>
);

export const ArticleGridSkeleton: React.FC<{ count?: number }> = ({ count = 6 }) => (
  <div className="grid grid-cols-1 gap-[14px] sm:grid-cols-2 sm:gap-6 lg:grid-cols-3" role="status" aria-label="در حال بارگذاری مقالات">
    {Array.from({ length: count }).map((_, i) => (
      <ArticleCardSkeleton key={i} />
    ))}
  </div>
);

/** خطای شبکه با دکمهٔ تلاش دوباره */
export const BlogErrorState: React.FC<{ title?: string; message?: string; onRetry?: () => void }> = ({
  title = 'خطا در بارگذاری مقالات',
  message = 'ارتباط با سرور برقرار نشد. لطفاً اتصال اینترنت خود را بررسی کرده و مجدداً تلاش نمایید.',
  onRetry,
}) => (
  <div role="alert" className="flex flex-col items-center gap-1 rounded-[12px] border border-[#fecaca] bg-[rgba(254,242,242,0.3)] px-4 py-10 text-center">
    <span className="flex h-12 w-12 items-center justify-center rounded-full border border-[#fecaca] bg-[#fef2f2]">
      <BlogIcon name="error-alert" width={24} height={24} />
    </span>
    <h3 className="pt-2 text-[14px] font-bold leading-5 text-[#222]">{title}</h3>
    <p className="max-w-[320px] pb-3 text-[12px] leading-4 text-[#666]">{message}</p>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className="flex min-h-[44px] items-center gap-2 rounded-[8px] bg-[#4a2e68] px-5 text-[12px] font-semibold text-white transition-colors hover:bg-[#392352]"
      >
        تلاش دوباره
        <BlogIcon name="retry" width={16} height={16} />
      </button>
    )}
  </div>
);

/** جست‌وجوی بدون نتیجه */
export const BlogEmptyState: React.FC<{ query?: string; onClear?: () => void }> = ({ query, onClear }) => (
  <div className="flex flex-col items-center gap-1 rounded-[8px] border border-dashed border-[#e6e4df] bg-[#f4f3f1] px-4 py-8 text-center">
    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#e6e4df]">
      <BlogIcon name="empty-search" width={24} height={24} />
    </span>
    <h3 className="pt-2 text-[14px] font-bold leading-5 text-[#222]">{query ? 'مقاله‌ای با این مشخصات پیدا نشد' : 'هنوز مقاله‌ای منتشر نشده است'}</h3>
    <p className="max-w-[384px] pb-3 text-[12px] leading-4 text-[#666]">
      {query
        ? 'املای واژه‌ها را بررسی کنید، از کلمات کلیدی عام‌تر استفاده کنید یا فیلترهای اعمال‌شده را بردارید.'
        : 'به‌زودی مقاله‌های تازه در این بخش منتشر می‌شود.'}
    </p>
    {onClear && (
      <button type="button" onClick={onClear} className="min-h-[44px] rounded-[8px] bg-[#4a2e68] px-4 text-[12px] font-semibold text-white transition-colors hover:bg-[#392352]">
        پاک‌کردن جست‌وجو و فیلترها
      </button>
    )}
  </div>
);
